import { call, put, takeEvery } from 'redux-saga/effects';

import { leaveMessageFormSubmitError, leaveMessageFormSubmitSuccess } from '../actions';
import * as api from '../actions/api';
import { LeaveMessageFormSubmitAction } from '../typedefs/actions';
import * as actionTypes from '../typedefs/actionTypes';

function* leaveMessage(action: LeaveMessageFormSubmitAction) {
    try {
        yield call(api.leaveMessage, action.payload);
        yield put(leaveMessageFormSubmitSuccess());
    } catch (e) {
        yield put(leaveMessageFormSubmitError());
    }
}

export default function* formSaga() {
    yield takeEvery(actionTypes.LEAVE_MESSAGE_FORM_SUBMIT, leaveMessage);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/formSaga.ts